module.exports = __webpack_public_path__ + "static/SELO_MLPT2026-1250c2e74dd8617b0a851ebb5101a9ed.png";